<template>
    <div
        class="relative flex items-center flex-col lg:flex-row"
        :style="{ color: footer.mainColor }"
    >
        <a
            :href="mailLink"
            @click.prevent="goToLink(mailLink)"
            v-if="footer.email"
            class="flex items-center px-2 text-sm"
        >
            <MailIcon class="h-4 w-4 mr-2" />
            <cUtilsEdit @edit="goToCompanyField('footerEmail')">
                <span>{{ footer.email }}</span>
            </cUtilsEdit>
        </a>
        <p v-if="showPhoneSeparator" class="hidden lg:block">|</p>
        <a
            :href="phoneLink"
            @click.prevent="goToLink(phoneLink)"
            v-if="footer.tel"
            class="flex items-center px-2 text-sm"
        >
            <PhoneIcon class="h-4 w-4 mr-2" />
            <cUtilsEdit @edit="goToCompanyField('footerTel')">
                <span>{{ footer.tel }}</span>
            </cUtilsEdit>
        </a>
        <p v-if="showAddressSeparator" class="hidden lg:block">|</p>
        <p v-if="showAddress" class="flex items-center px-2 text-sm">
            <HomeIcon class="h-4 w-4 mr-2" />
            <cUtilsEdit @edit="goToCompanyField('footerAddress')">
                <span>{{ address }}</span>
            </cUtilsEdit>
        </p>
    </div>
</template>

<script>
import { MailIcon, HomeIcon, PhoneIcon } from "@easy/ui/icons";
import { useLegalGoTo } from "@/views/tools/legal/utils/useLegalGoTo";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";

import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "cAddress",
    components: {
        PhoneIcon,
        HomeIcon,
        MailIcon,
        cUtilsEdit,
    },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToCompanyField } = useLegalGoTo();
        return {
            goToLink,
            goToCompanyField,
        };
    },
    props: {
        footer: Object,
    },
    computed: {
        phoneLink() {
            return `tel:${this.footer.tel}`;
        },
        mailLink() {
            return `mailto:${this.footer.email}`;
        },
        showPhoneSeparator() {
            return this.footer.email && this.footer.tel;
        },
        showAddressSeparator() {
            return this.showAddress && this.footer.email;
        },
        showAddress() {
            const { companyData } = this.footer;
            return (
                companyData.streetAddress ||
                companyData.streetNumber ||
                companyData.houseNumber ||
                companyData.postalCode ||
                companyData.city
            );
        },
        showCitySeparator() {
            const { companyData } = this.footer;
            return (
                (companyData.streetAddress ||
                    companyData.streetNumber ||
                    companyData.houseNumber) &&
                (companyData.postalCode || companyData.city)
            );
        },
        address() {
            const { companyData } = this.footer;
            return `${companyData.streetAddress || ""} ${companyData.streetNumber || ""}${companyData.houseNumber ? "/" : ""}${companyData.houseNumber || ""}${this.showCitySeparator ? ", " : ""}${companyData.postalCode || ""} ${companyData.city || ""}`;
        },
    },
};
</script>
